(() => {
  const config = window.__trackingConsentConfig || {};
  const hotjarConfig = config.hotjar || {};

  const onWindowLoad = (callback) => {
    if (document.readyState === 'complete') {
      callback();
      return;
    }
    window.addEventListener('load', callback, { once: true });
  };

  const withConsentApi = (callback) => {
    if (!window.Shopify || !Shopify.loadFeatures) {
      callback();
      return;
    }

    Shopify.loadFeatures(
      [
        {
          name: 'consent-tracking-api',
          version: '0.1'
        }
      ],
      (error) => {
        if (error) {
          callback();
          return;
        }
        callback();
      }
    );
  };

  const withTrackingConsent = (callback) => {
    let didRun = false;
    const runOnce = () => {
      if (didRun) {
        return;
      }
      didRun = true;
      callback();
    };

    if (!window.Shopify || !Shopify.customerPrivacy || !Shopify.customerPrivacy.userCanBeTracked) {
      runOnce();
      return;
    }

    try {
      if (Shopify.customerPrivacy.userCanBeTracked()) {
        runOnce();
        return;
      }
    } catch (error) {
      runOnce();
      return;
    }

    document.addEventListener('trackingConsentAccepted', runOnce, { once: true });
    document.addEventListener(
      'visitorConsentCollected',
      () => {
        try {
          if (Shopify.customerPrivacy.userCanBeTracked()) {
            runOnce();
          }
        } catch (error) {
          runOnce();
        }
      },
      { once: true }
    );
  };

  const copyAttribute = (source, target, name) => {
    if (source.hasAttribute(name)) {
      target.setAttribute(name, source.getAttribute(name));
    }
  };

  const loadDelayedScripts = () => {
    const delayedScripts = document.querySelectorAll('script[data-delayed-src]');
    if (!delayedScripts.length) {
      return;
    }

    delayedScripts.forEach((script) => {
      const src = script.getAttribute('data-delayed-src');
      if (!src) {
        return;
      }

      const newScript = document.createElement('script');
      const hadAsync = script.hasAttribute('async');
      const hadDefer = script.hasAttribute('defer');

      if (hadAsync) {
        newScript.async = true;
      }
      if (hadDefer) {
        newScript.defer = true;
      }
      if (!hadAsync && !hadDefer) {
        newScript.async = false;
      }

      copyAttribute(script, newScript, 'type');
      copyAttribute(script, newScript, 'id');
      copyAttribute(script, newScript, 'crossorigin');
      copyAttribute(script, newScript, 'referrerpolicy');
      copyAttribute(script, newScript, 'integrity');
      copyAttribute(script, newScript, 'nonce');

      Array.from(script.attributes).forEach((attr) => {
        if (attr.name.startsWith('data-') && attr.name !== 'data-delayed-src') {
          newScript.setAttribute(attr.name, attr.value);
        }
      });

      newScript.src = src;

      script.parentNode.removeChild(script);
      (document.head || document.body).appendChild(newScript);
    });
  };

  const loadScript = (src) => {
    const script = document.createElement('script');
    script.async = true;
    script.src = src;
    (document.head || document.body).appendChild(script);
  };

  const initHotjar = () => {
    if (!hotjarConfig || !hotjarConfig.id) {
      return;
    }

    if (window.hj) {
      return;
    }

    window.hj = window.hj || function () {
      (window.hj.q = window.hj.q || []).push(arguments);
    };

    window._hjSettings = {
      hjid: hotjarConfig.id,
      hjsv: hotjarConfig.sv || 6
    };

    loadScript(`https://static.hotjar.com/c/hotjar-${window._hjSettings.hjid}.js?sv=${window._hjSettings.hjsv}`);
  };

  onWindowLoad(() => {
    withConsentApi(() => {
      withTrackingConsent(() => {
        const hasDelayedHotjar = !!document.querySelector(
          'script[data-delayed-src*="static.hotjar.com/c/hotjar-"]'
        );

        loadDelayedScripts();

        if (!hasDelayedHotjar) {
          initHotjar();
        }
      });
    });
  });
})();
